<!-- Modal Backdrop -->
<div class="review-modal-wrapper" id="reviewModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
    aria-modal="true" style="display: block;" (click)="closePopup()">
    <div class="review-modal-content" role="document" (click)="$event.stopPropagation()">
        <div class="review-body-container">
            <div class="modal-header border-0 justify-content-between position-relative px-4">
                <h5 class="modal-title">Review It</h5>
                <!-- custom close -->
                <img [src]="commonImagePath +'close_btn_sidebar.webp'" alt="Close" (click)="closePopup()"
                    class="cursor-pointer" />
            </div>
            <div class="modal-body" id="review_submit">
                <!-- product info -->
                <div class="d-flex align-items-start gap-3 mb-3">
                    <img [src]="productImg" alt="product" class="review-thumb"
                        (error)="onImageError($event)" />
                    <div class="flex-grow-1">
                        <div class="product-name">{{ productName }}</div>
                        <div class="rating-row mt-1">
                            <div class="review-stars me-2">
                                <ng-container *ngIf="(avgRating | starpipe: 'fullStar') > 0">
                                    <ng-container *ngFor="let fullstar of (avgRating | starpipe: 'fullStar': true)">
                                        <i class="fas fa-star star full fullStar fa-sm"></i>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="(avgRating | starpipe: 'halfStar') > 0">
                                    <ng-container *ngFor="let halfstar of (avgRating | starpipe: 'halfStar': true)">
                                        <i class="fas fa-star-half-alt half-star fa-sm"></i>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="(avgRating | starpipe: 'noStar') > 0">
                                    <ng-container *ngFor="let noStar of (avgRating | starpipe: 'noStar': true)">
                                        <i class="fas fa-star star empty grey-star fa-sm"></i>
                                    </ng-container>
                                </ng-container>
                            </div>
                            <div class="reviews-count">
                                ({{ reviewsCount }}
                                {{ reviewsCount > 1 ? 'reviews' : 'review' }})
                            </div>
                        </div>
                    </div>
                </div>
                <!-- thin divider -->
                <div class="divider mb-3"></div>
                <!-- form -->
                <form class="review-form" novalidate [formGroup]="reviewItForm" (ngSubmit)="submitReview()">
                    <div *ngIf="isSuccess" [class.fade-out]="isSuccess" class="alert alert-success" role="alert">
                        Your review was submitted successfully!
                    </div>
                    <!-- First Name -->
                    <div class="mb-2">
                        <input type="text" placeholder="First Name" name="first_name" id="first_name"
                            class="form-control custom-input" formControlName="first_name" required />
                        <span class="validation-error"
                            *ngIf="reviewItForm.get('first_name').invalid &&(reviewItForm.get('first_name').dirty ||reviewItForm.get('first_name').touched ||isSubmitClicked)">
                            First name is required
                        </span>
                    </div>
                    <!-- Email -->
                    <div class="mb-2">
                        <input type="email" placeholder="Email Address" name="email_address" id="email_address"
                            class="form-control custom-input" formControlName="email_address" />
                        <div class="validation-error"
                            *ngIf="reviewItForm.get('email_address').hasError('email') &&!reviewItForm.get('email_address').hasError('required') &&(reviewItForm.get('email_address').dirty ||reviewItForm.get('email_address').touched ||isSubmitClicked)">
                            Invalid email address.
                        </div>
                        <span class="validation-error"
                            *ngIf="reviewItForm.get('email_address').hasError('required') &&(reviewItForm.get('email_address').dirty ||reviewItForm.get('email_address').touched ||isSubmitClicked)">
                            Email is required.
                        </span>
                    </div>
                    <!-- Review Title -->
                    <div class="mb-2">
                        <input class="form-control custom-input" type="text" placeholder="Review Title"
                            formControlName="title" required />
                        <span class="validation-error"
                            *ngIf="reviewItForm.get('title').invalid &&(reviewItForm.get('title').dirty ||reviewItForm.get('title').touched ||isSubmitClicked)">
                            Review title is required.
                        </span>
                    </div>
                    <!-- Comments -->
                    <div class="mb-3">
                        <textarea rows="5" placeholder="Comments" name="comments" id="comment"
                            class="form-control custom-textarea" formControlName="comments"></textarea>
                        <span class="validation-error"
                            *ngIf="reviewItForm.get('comments').invalid &&(reviewItForm.get('comments').dirty ||reviewItForm.get('comments').touched ||isSubmitClicked)">
                            Comments are required.
                        </span>
                    </div>
                    <!-- Appearance -->
                    <div class="mb-2">
                        <select class="form-select custom-select" aria-label="Appearance" name="appearance"
                            id="appearance" formControlName="appearance" required>
                            <option value="0">Select Appearance</option>
                            <option *ngFor="let i of [1,1.5,2,2.5,3,3.5,4,4.5,5]" [value]="i">
                                {{ i }}
                            </option>
                        </select>
                    </div>
                    <span class="validation-error"
                        *ngIf=" reviewItForm.get('appearance').invalid &&(reviewItForm.get('appearance').dirty ||reviewItForm.get('appearance').touched ||isSubmitClicked)">
                        Appearance is required.
                    </span>
                    <!-- Installation -->
                    <div class="mb-2">
                        <select class="form-select custom-select" aria-label="Installation" name="installation"
                            id="review_installation" formControlName="installation" required>
                            <option value="0">Select Installation</option>
                            <option *ngFor="let i of [1,1.5,2,2.5,3,3.5,4,4.5,5]" [value]="i">
                                {{ i }}
                            </option>
                        </select>
                    </div>
                    <span class="validation-error"
                        *ngIf="reviewItForm.get('installation').invalid &&(reviewItForm.get('installation').dirty ||reviewItForm.get('installation').touched ||isSubmitClicked)">
                        Installation rating is required.
                    </span>
                    <!-- Price / Value -->
                    <div class="mb-2">
                        <select class="form-select custom-select" aria-label="PriceValue" name="price_value"
                            id="review_price_value" formControlName="price_value" required>
                            <option value="0">Select Price / Value</option>
                            <option *ngFor="let i of [1,1.5,2,2.5,3,3.5,4,4.5,5]" [value]="i">
                                {{ i }}
                            </option>
                        </select>
                    </div>
                    <div class="validation-error"
                        *ngIf="reviewItForm.get('price_value').invalid &&(reviewItForm.get('price_value').dirty ||reviewItForm.get('price_value').touched ||isSubmitClicked)">
                        Price value rating is required.
                    </div>
                    <!-- Quality -->
                    <div class="mb-3">
                        <select class="form-select custom-select" aria-label="Quality" name="quality" id="quality"
                            formControlName="quality" required>
                            <option value="0">Select Quality</option>
                            <option *ngFor="let i of [1,1.5,2,2.5,3,3.5,4,4.5,5]" [value]="i">
                                {{ i }}
                            </option>
                        </select>
                    </div>
                    <div class="validation-error"
                        *ngIf="reviewItForm.get('quality').invalid &&(reviewItForm.get('quality').dirty ||reviewItForm.get('quality').touched ||isSubmitClicked)">
                        Quality is required.
                    </div>
                    <!-- Product Key -->
                    <div class="validation-error"
                        *ngIf="reviewItForm.get('product_key').invalid &&(reviewItForm.get('product_key').dirty ||reviewItForm.get('product_key').touched ||isSubmitClicked) ">
                        Product is not valid.
                    </div>
                    <!-- Submit -->
                    <div class="d-flex justify-content-start mt-3">
                        <button type="submit" class="btn btn-submit">SUBMIT</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>